import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import './AdminLogin.css'; // Import the CSS file

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!password.trim()) {
      setError('Please enter password');
      return;
    }

    setIsLoading(true);

    try {
      // Demo password check (replace with real API in production)
      if (password === 'VikramDyD@0720') {
        onLogin();
      } else {
        setError('Invalid password');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="login-card"
      >
        <div className="login-header">
          <div className="admin-logo">
            <span className="logo-text">DYLORA</span>
            {/* <span className="logo-accent">PRO</span> */}
          </div>
          <h2 className="login-title">Admin Portal</h2>
          <p className="login-subtitle">Enter password to access dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <div className="input-container">
              <FiLock className="input-icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="password-input"
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="eye-button"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {error && <div className="error-message">{error}</div>}
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            className="submit-button black-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Verifying...' : 'Access Dashboard'}
          </motion.button>
        </form>

        <div className="login-note">
          <p className="note-text">
            <strong>Note:</strong> This page is password protected. 
            Only authorized personnel can access the dashboard.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;